<template>
    <div component="Contracts">
        <page-header :icon="'article'" :text="'Contracts'"></page-header>
        <section container="detail">
            <list-and-detail
                ref="listDetail"
                :list="getTransformedContracts"
                :config="tableConfig"
                :isDetail="getIsDetail"
            >
                <template slot="detail">
                    <contract-detail
                        v-if="getContract"
                        :contract="getContract"
                        :config="tableConfig"
                        @hideDetail="hideDetail"
                    ></contract-detail>
                </template>
            </list-and-detail>
        </section>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';
import ListAndDetail from '@/components/.global/ScrollTable/ListAndDetail/ListAndDetail.vue';
import ContractDetail from './ContractDetail.vue';

export default {
    name: 'Contracts',

    data() {
        return {
            tableConfig: [
                {
                    id: 0,
                    caption: '',
                    type: 'text',
                    width: 0,
                    flex: 0,
                    hidden: true,
                },
                {
                    id: 1,
                    caption: 'Date',
                    type: 'text',
                    width: '70px',
                    flex: 0,
                    hidden: false,
                },
                {
                    id: 2,
                    caption: 'Project',
                    type: 'text',
                    width: 0,
                    flex: 2,
                    bold: true,
                    hidden: false,
                },
                {
                    id: 3,
                    caption: 'Type',
                    type: 'text',
                    width: 0,
                    flex: 0,
                    hidden: false,
                },
                {
                    id: 4,
                    caption: 'Html',
                    type: 'text',
                    width: 0,
                    flex: 0,
                    hidden: true,
                },
            ],
        };
    },

    created() {
        this.loadContracts();
        if (this.$route.params.id) {
            this.loadContract(this.$route.params.id.replace(/[^\d]*/, ''));
        }
    },

    methods: {
        ...mapActions(['loadContract', 'loadContracts']),
        hideDetail() {
            this.$refs.listDetail.hideDetail();
        },
    },

    computed: {
        ...mapGetters(['getContract', 'getContracts']),

        getTransformedContracts() {
            return this.getContracts.map((record) => record.transform());
        },

        getIsDetail() {
            return !!this.$route.params.id;
        },
    },

    watch: {
        '$route.params.id'(newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                this.loadContract(newVal.replace(/[^\d]*/, ''));
            }
        },
    },

    components: {
        PageHeader,
        ListAndDetail,
        ContractDetail,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Contracts'] {
    [container='detail'] {
        padding-top: 15px;
    }
}
</style>
